<template>
  <div class="app-layout">
    <header class="app-header cf">
      <div class="container">
        <el-row>
          <el-col :span="5">
            <a href="/home" class="app-logo">
              <h1>分享收客</h1>
            </a>
          </el-col>
          <el-col :span="19">
            <ul class="app-nav fl-l">
              <li>
                <router-link to="/index" :class="{active: isActive('/index')}">首页</router-link>
              </li>
              <li>
                <router-link to="/share" :class="{active: isActive('/share')}">内容管理</router-link>
              </li>
              <li>
                <router-link to="/ad" :class="{active: isActive('/ad')}">精准营销</router-link>
              </li>
            </ul>
            <div class="app-userInfo fl-r">
              <span v-if="!user">
                <el-button class="app-orang" @click.native="experienceLogin">立即体验</el-button>
                <el-button type="success" @click.native="login">登录</el-button>
              </span>
              <span v-else>
                您好，{{user.realname || user.username}}
                <small style="color: #00BCD4;">({{user.type_}})</small>
                <span class="pl-xs pr-xs" style="color: #ccc;">|</span>
                <el-button type="info" size="mini" class="ml-s" @click.native="back">进入可可兔</el-button>
                <el-button type="success" size="mini" class="ml-s" @click.native="login">退出</el-button>
              </span>
            </div>
          </el-col>
        </el-row>
      </div>
    </header>
    <main class="app-main cf">
      <router-view></router-view>
    </main>
    <footer class="app-footer">
      <p>Copyright(©) 2017 www.keketour.com 深圳市众游汇网络科技有限公司 All Rights Re</p>
      <a href="http://szcert.ebs.org.cn/CF52D6F1-F06A-4BEE-BD73-D7C41700F938" target="__blank">
        <img class="app-footer__" src="./img/bureau.jpg">
      </a>
    </footer>
  </div>
</template>

<script>
import authService from 'service/authService'
import config from 'config'

export default {
  data: () => ({
    adminUrl: config.urls.platform
  }),

  computed: {
    user () {
      return authService.currentUser
    }
  },

  methods: {
    // 返回
    back () {
      location.replace(this.adminUrl)
    },

    // 退出和登陆
    login () {
      authService.login()
    },

    // router-link 是否处于激活状态
    isActive (path) {
      return this.$route.matched.map(item => item.path).join('').indexOf(path) === 0
    },

    // 体验账号
    experienceLogin () {
      location.assign(this.$dm.get('shareapi') + '/adv/advert/sharelogin')
    }
  }
}
</script>

<style scoped>
.app-layout {
  margin: 0;
  padding: 0;
}

.app-header {
  position: relative;
  height: 68px;
  border-top: 4px solid #00BCD4;
  background: #fff;
  box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.16);
}

.app-logo {
  display: inline-block;
  color: transparent;
  margin: 10px 0;
  width: 160px;
  height: 48px;
  background-repeat: no-repeat;
  background-position: -5px 0px;
  background-image: url(../assets/img/app-logo.png);
  background-size: contain;
  text-decoration: none;
  text-indent: -100%;
  overflow: hidden;
}

.app-logo h1 {
  margin: 0;
}

.app-logo > a {
  color: #00BCD4;
  text-decoration: none;
}

.app-nav {
  margin: 0;
  padding: 0;
}

.app-nav li {
  display: inline-block;
}

.app-nav li a {
  display: block;
  padding: 0 20px;
  line-height: 40px;
  color: #666;
  text-decoration: none;
  font-size: 16px;
  margin: 14px 6px;
}

.app-nav li a.active {
  background: #00BCD4;
  border-radius: 50px;
  color: #fff;
}

.app-userInfo {
  line-height: 68px;
  font-size: 14px;
}

.app-main {
  background: #e9ecf1;
  min-height: 400px;
}

.app-footer {
  min-height: 120px;
  text-align: center;
  background-color: #485156;
  font-size: 16px;
  line-height: 38px;
  color: #fff;
  overflow: hidden;
}

.app-footer img {
  width: 84px;
  height: 37px;
}

.app-orang {
  background-color: rgba(255, 137, 32, 1);
  color: #fff;
  border: none;
}

.app-orang:hover {
  color: #fff;
  background-color: rgba(255, 137, 32, 0.8);
}
</style>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
}
.container-fuild {
  max-width: 1200px;
  min-width: 480px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// layout.vue?f43b184c